<template>
    <div class="section-login">
        <div class="section-login__wrapper">
            <div class="section-login__container">
                <h1 class="title-custom t-transform-cap">
                    {{ getTranslatedText("login") }}
                </h1>
                 <div class="method-login">
                    <ButtonCustom
                        v-if="this.methodLogin === 1"
                        classBtn="button-method-login"
                        text="use email to login"
                        typeBtn="button"
                        type="primary"
                        @onClickButton="onChangeMethodLogin"
                    />
                    <ButtonCustom
                        v-if="this.methodLogin === 2"
                        classBtn="button-method-login"
                        text="use phone to login"
                        typeBtn="button"
                        type="primary"
                        @onClickButton="onChangeMethodLogin"
                    />
                </div>
                <div class="form-container">
                    <FormCommon
                        :formItem="
                            methodLogin === 1 ? formItemPhone : formItemEmail
                        "
                        :dataForm="dataForm"
                        @update-form-data="updateFormData"
                        @onSubmitForm="onSubmitForm"
                        @onToggleShowPassword="onToggleShowPassword"
                    >
                        <b-input-group-prepend
                            slot="propend-phone-number"
                            class="phone-code"
                        >
                            <button
                                class="show-dropdown"
                                type="button"
                                @click="showDropDow"
                            >
                                <img
                                    class="user-avatar"
                                    :src="
                                        require(`@/assets/images/flags/${dataForm.flag}`)
                                    "
                                    :alt="dataForm.flag"
                                />
                                <span class="name-country">{{
                                    dataForm.nameCountry
                                }}</span>
                                ({{ dataForm.calling_code }})
                            </button>

                            <b-dropdown ref="select_phone_code">
                                <b-form-input
                                    v-model="textSearchPhoneNumber"
                                    :placeholder="
                                        getTranslatedText('Search')
                                    "
                                    @input="onChangeFilterPhoneNumbers"
                                ></b-form-input>
                                <b-dropdown-item
                                    @click="selectPhoneCode(item)"
                                    v-for="(item, index) in phoneNumbersFilter"
                                    :key="index"
                                >
                                    <div>
                                        <img
                                            class="user-avatar"
                                            :src="
                                                require(`@/assets/images/flags/${item.flag}`)
                                            "
                                            :alt="item.flag"
                                        />
                                        <span class="name-country">{{
                                            item.name
                                        }}</span>
                                        ({{ item.number }})
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-input-group-prepend>
                        <div class="box-btn" slot="button">
                            <ButtonCustom
                                classBtn="btn-forgot-password"
                                typeBtn="button"
                                type="primary"
                                text="forgot password?"
                                @onClickButton="onClickForgotPassword()"
                            />
                            <ButtonCustom
                                classBtn="login-btn-continue"
                                typeBtn="submit"
                                type="primary"
                                text="login"
                                :isLoading="isLoadingButton"
                            />
                        </div>
                    </FormCommon>
                </div>
                <div class="box-social-divider">
                    <div class="social-divider">
                        <span>{{ getTranslatedText("or") }}</span>
                    </div>
                </div>
                <SocialSignUp @onLogin="onSubmitForm" :isLoadingButton="isLoadingButton"/>
                <div class="section-login__login-bottom__desktop">
                    <div class="section-login__create-account__des t-transform-cap">
                        {{ getTranslatedText("don't have account?") }}
                    </div>
                    <div
                        @click="$router.push('/register')"
                        class="section-login__create-account"
                    >
                        {{ getTranslatedText("Create Account") }}
                    </div>
                </div>
                <div class="login-bottom">
                    <p class="t-transform-cap">
                        {{ getTranslatedText("don't have account?") }}
                    </p>
                    <ButtonCustom
                        @onClickButton="$router.push('/register')"
                        classBtn="button-create-account"
                        text="create account"
                        typeBtn="button"
                        type="primary"
                    />
                </div>
            </div>
        </div>
        <Toast :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>
import Toast from "@/components/common/toast/Toast.vue";
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";

import AuthService from "@/services/auth.service";
import languageMixin from "@/mixins/language/language-mixin";

import { phoneNumbers } from "@/resources/phoneNumber";
import {
    filterFullTextSearch,
    isArrayEmpty,
    isStrEmpty,
    validateEmail,
} from "@/components/common/utils";

import SocialSignUp from '@/components/common/socialLogin'


export default {
    mixins: [languageMixin],
    components: {
        FormCommon,
        ButtonCustom,
        Toast,
        SocialSignUp
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            codeOTP: "",
            methodLogin: 2,
            dataForm: {
                phone: "",
                password: "",
                email: "",
                calling_code: "+968",
                code: "+968",
                flag: "Flag_of_Oman.svg",
                nameCountry: "Oman",
            },
            phoneNumbersFilter: phoneNumbers,
            textSearchPhoneNumber: "",
            phoneNumbers,
            isLoadingButton: false,
            formItemPhone: [
                {
                    type: "input-group",
                    typeInput: "number",
                    placeholder: "",
                    name: "phone",
                    label: "phone Number",
                    for: "input-phone",
                    id: "input-phone-login",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    state: null,
                    textInvalid: "Please enter phone",
                },
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    label: "password",
                    placeholder: "password",
                    name: "password",
                    required: true,
                    hideIconRq: true,
                    for: "input-password",
                    id: "input-password",
                },
            ],
            formItemEmail: [
                {
                    type: "input",
                    typeInput: "email",
                    label: "email",
                    placeholder: "email",
                    name: "email",
                    required: true,
                    hideIconRq: true,
                    showIconRequired: true,
                    for: "input-email",
                    id: "input-email",
                    state: null,
                    textInvalid: "Please enter email",
                },
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    label: "password",
                    placeholder: "password",
                    name: "password",
                    required: true,
                    hideIconRq: true,
                    for: "input-password",
                    id: "input-password",
                },
            ],
        };
    },
    methods: {
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        updateFormData(item) {
            let { value, name } = item;
            this.dataForm[name] = value;
        },

        onChangeMethodLogin() {
            this.methodLogin = this.methodLogin === 1 ? 2 : 1;
        },

       async onFinishLogin() {
            let listGame =  !isStrEmpty(localStorage.getItem("list_games")) ? JSON.parse(localStorage.getItem("list_games")) : []
            let totalCart = !isStrEmpty(localStorage.getItem("total_items")) ? parseInt(localStorage.getItem("total_items")) : 0


            if(isArrayEmpty(listGame)) {
                await this.$router.push("/");
                return false
            }

            try {
                const resp = await AuthService.getListCart();
                if(resp.status === 200) {
                    localStorage.setItem("isLogin", true);

                    let list_block_tmp = totalCart > 0 ? JSON.parse(localStorage.getItem('list_block_tmp')) : []
                    let list_block_api = parseInt(resp.data?.amount) > 0 ? JSON.parse(resp.data.cart_data) : []

                    if(!isArrayEmpty(list_block_tmp)) {

                        list_block_tmp = list_block_api.concat(list_block_tmp)
                        list_block_tmp = [...new Set(list_block_tmp)]

                        let amount = 0;

                        list_block_tmp.map((x) => {
                            amount += x.date.length;
                        });

                        let param = {
                            cart_data: list_block_tmp,
                            items: list_block_tmp.length,
                            amount,
                        };

                        const respSaveCart = await AuthService.saveListCart(param)

                        if (respSaveCart.status === 200) {
                            this.$store.dispatch( "onChangeAnountCart", parseInt(param.amount));
                            localStorage.setItem( "list_block_tmp", JSON.stringify(list_block_tmp));
                            localStorage.setItem( "list_block", JSON.stringify(list_block_tmp));
                            localStorage.setItem( "total_items", param.amount);
                            window.location.href = '/checkout'
                        }
                    } else {
                        let amount = resp?.data?.amount ? parseInt(resp.data.amount) : 0;

                        localStorage.setItem( "list_block_tmp", JSON.stringify(list_block_api));
                        localStorage.setItem( "list_block", JSON.stringify(list_block_api));
                        localStorage.setItem( "total_items", amount);

                        amount !== 0 ? window.location.href = '/checkout' :  await this.$router.push("/");
                    }

                } else {
                    await this.$router.push("/");
                }
            } catch (error) {
                this.isLoadingButton = false
                console.log(error)
            }

        },

        onSubmitForm(paramLoginSocial) {
            this.isLoadingButton = true
            if(!isStrEmpty(paramLoginSocial?.idToken)) {
                AuthService.loginByGoogle(paramLoginSocial.idToken, paramLoginSocial.type).then(res => {
                    if (res.status === 200) {
                        this.onFinishLogin()
                    } else {
                        this.isLoadingButton = false
                        this.showToast(this.getTranslatedText(res.message), "error");
                    }
                })
            } else if (this.methodLogin === 1 && this.dataForm.phone !== "") {
                AuthService.loginByPhone(
                    this.dataForm.phone,
                    this.dataForm.password,
                    this.dataForm.calling_code.replaceAll("\\+", "")
                ).then((res) => {
                    if (res.status === 200) {
                        this.onFinishLogin()
                    } else {
                        this.isLoadingButton = false
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            } else {
                AuthService.loginByEmail(
                    this.dataForm.email,
                    this.dataForm.password
                ).then((res) => {
                    if (res.status === 200) {
                        this.onFinishLogin()
                    } else {
                        this.isLoadingButton = false
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            }
        },

        onClickForgotPassword() {
            this.$router.push('/forgot-password')
        },

        // call api check email and phone
        async onBurInputFormData(event, phoneCode) {
            const { name, value } = event.target;
            let { calling_code, phone, email } = this.dataForm;

            switch (true) {
                // check email empty but phone no empty
                case this.formItemEmail[0].state !== null &&
                    name === "email" &&
                    value === "" &&
                    !isStrEmpty(phone):
                    this.formItemEmail[0].state = null;
                    break;
                // check Incorrect email format
                case name === "email" &&
                    !isStrEmpty(value) &&
                    !validateEmail(value):
                    this.formItemEmail[0].state = false;
                    this.formItemEmail[0].textInvalid =
                        "Incorrect email format";
                    this.dataForm.email = value;
                    break;
                // check email already exist
                case name === "email" &&
                    validateEmail(value) &&
                    value !== email:
                    try {
                        const res = await AuthService.checkMail(value);

                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItemEmail[0].state = false;
                            this.formItemEmail[0].textInvalid = message;
                        } else {
                            this.formItemEmail[0].state = null;
                        }
                        this.dataForm.email = value;
                    } catch (error) {
                        this.formItemEmail[0].textInvalid = error;
                    }
                    break;
                // check phone already exist and change code phone
                case (name === "phone" && value !== phone) ||
                    !isStrEmpty(phoneCode):
                    // calling_code check change code phone

                    calling_code = !isStrEmpty(phoneCode)
                        ? phoneCode.replaceAll("\\+", "")
                        : calling_code.replaceAll("\\+", "");

                    try {
                        const res = await AuthService.checkPhone(
                            calling_code,
                            value
                        );
                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItemPhone[0].state = false;
                            this.formItemPhone[0].textInvalid = message;
                        } else {
                            this.formItemPhone[0].state = null;
                        }

                        this.dataForm.phone = value;
                    } catch (error) {
                        this.formItemPhone[0].textInvalid = error;
                    }
                    break;
                default:
                    break;
            }
        },
        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone,
                        name: "phone",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
        },
        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },
        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
        },

        onToggleShowPassword(name) {
            let element = this.methodLogin === 2 ? this.formItemEmail : this.formItemPhone
            let index = element.findIndex(x => x.name === name)
            if(index !== -1 ) {
                if(this.methodLogin === 2) {
                    this.formItemEmail[index].typeShow = this.formItemEmail[index].typeShow === 'password' ? 'text' : 'password'
                } else {
                     this.formItemPhone[index].typeShow = this.formItemPhone[index].typeShow === 'password' ? 'text' : 'password'
                }
            }
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/authenticate/_login.scss" />
